import { Heading1 } from "../../../common/components/styled/styled";
import { FormContainer } from "../../customer/customerManagement/styles";
import { useTranslation } from "react-i18next";
import { FieldValues, FormProvider, useForm } from "react-hook-form";
import { useAppDispatch } from "../../../app/hooks";
import { fetchEvents } from "../settingsActions";
import { useState } from "react";
import {
  InspectEventsFormValues,
  InspectEventsResponse,
  Service,
} from "../settingsApi";
import { isFulfilled } from "@reduxjs/toolkit";
import TestingFormFields from "./TestingFormFields";
import isEmpty from "../../../common/helpers/isEmpty";
import EventAccodions from "./EventAccodions";

import { BackgroundJobsPanel } from "../backgroundJobs/BackgroundJobsPanel";
import { TestingUtilitiesTitle } from "../styles";

export const TestingUtilities = () => {
  const [events, setEvents] = useState<InspectEventsResponse[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation("settings");

  const dispatch = useAppDispatch();

  const defaultValues: InspectEventsFormValues = {
    id: "",
    aggregateType: "",
    service: Service.Default,
  };

  const methods = useForm({
    defaultValues,
    mode: "onChange",
  });
  const {
    formState: { isSubmitted },
  } = methods;
  const showEmptyState = isSubmitted && isEmpty(events) && !isLoading;

  const onSubmit = (fieldValues: FieldValues) => {
    const filters = {
      id: fieldValues.id,
      aggregateType: fieldValues.aggregateType,
      service: fieldValues.service,
    };
    setIsLoading(true);
    dispatch(fetchEvents(filters)).then((action) => {
      if (isFulfilled(action)) {
        setEvents(action.payload);
      }
      setIsLoading(false);
    });
  };

  return (
    <>
      <FormContainer maxWidth="1000px">
        <Heading1>{t("testingTools")}</Heading1>
        <TestingUtilitiesTitle>{t("testingTools")}</TestingUtilitiesTitle>
        <FormProvider {...methods}>
          <TestingFormFields isLoading={isLoading} onSubmit={onSubmit} />
        </FormProvider>
        <EventAccodions
          isLoading={isLoading}
          events={events}
          showEmptyState={showEmptyState}
        />
        <BackgroundJobsPanel />
      </FormContainer>
    </>
  );
};

export default TestingUtilities;
